export default __webpack_public_path__ + "static/media/clean.151f935e.PNG";